/**
 * 未登录用户点订阅时弹出的引导 Modal —— v0.9.3。
 *
 * 两个按钮：ログイン / 新規登録。两者都把当前完整 URL（含 ?promo=xxx）
 * 作为 redirect_uri 透传给 admin，回跳后保留 promo param。
 */
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const getAdminBaseUrl = () => {
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return 'https://localhost:5174';
  }
  return import.meta.env.VITE_ADMIN_URL || '';
};

interface Props {
  opened: boolean;
  onClose: () => void;
}

export const AuthChoiceModal = ({ opened, onClose }: Props) => {
  const { t } = useTranslation();

  const go = (path: '/auth/login' | '/auth/register') => {
    const adminBase = getAdminBaseUrl();
    const redirectUri = btoa(encodeURI(window.location.href));
    window.location.href = `${adminBase}${path}?redirect_uri=${redirectUri}`;
  };

  return (
    <Modal opened={opened} onClose={onClose} title={t('pricing.auth_required_title')} centered>
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          {t('pricing.auth_required_message')}
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            {t('pricing.cancel')}
          </Button>
          <Button variant="light" onClick={() => go('/auth/register')}>
            {t('pricing.button_register')}
          </Button>
          <Button onClick={() => go('/auth/login')}>{t('pricing.button_login')}</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
